import { Filter, SelectFilter, SelectOption } from './FilterTypes';
import { wfpFormat } from './utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createSelectOptionLabel(nickName: Record<string, any>, filterName: string) {
    if (filterName === 'vendorId') {
        return nickName.nickName;
    } else if (filterName === 'partnerId') {
        return nickName.name;
    } else {
        return nickName.firstName + ' ' + nickName.lastName;
    }
}

export function updateFiltersWithNickNames(entityNames, filters: Filter[], filterName: string): Filter[] {
    const entityOptions = entityNames.map(
        (entityName) => new SelectOption(createSelectOptionLabel(entityName, filterName), entityName.id)
    );
    const entityFilterIndex = filters.findIndex((filter) => filter.name === filterName);
    const entityFilter = filters[entityFilterIndex] as SelectFilter;
    const newEntityFilter = { ...entityFilter, options: entityOptions };

    const newFilters = [...filters];
    newFilters[entityFilterIndex] = newEntityFilter;
    return newFilters;
}

export function updateFiltersWithBranchCodes(branchCodes: string[], filters: Filter[], filterName: string): Filter[] {
    const entityOptions = branchCodes.map((entityName) => new SelectOption(entityName, entityName));

    const entityFilterIndex = filters.findIndex((filter) => filter.name === filterName);
    const entityFilter = filters[entityFilterIndex] as SelectFilter;
    const newEntityFilter = { ...entityFilter, options: entityOptions };

    const newFilters = [...filters];
    newFilters[entityFilterIndex] = newEntityFilter;
    return newFilters;
}

export function updateFiltersWithCategories(categories, filters: Filter[], filterName: string): Filter[] {
    const entityOptions = categories.map((category) => new SelectOption(category, category));

    const entityFilterIndex = filters.findIndex((filter) => filter.name === filterName);
    const entityFilter = filters[entityFilterIndex] as SelectFilter;
    const newEntityFilter = { ...entityFilter, options: entityOptions };

    const newFilters = [...filters];
    newFilters[entityFilterIndex] = newEntityFilter;
    return newFilters;
}

export function updateFiltersWithOrganizations(
    organizations: string[],
    filters: Filter[],
    filterName: string
): Filter[] {
    const entityOptions = organizations.map((organization) => new SelectOption(organization, organization));

    const entityFilterIndex = filters.findIndex((filter) => filter.name === filterName);
    const entityFilter = filters[entityFilterIndex] as SelectFilter;
    const newEntityFilter = { ...entityFilter, options: entityOptions };

    const newFilters = [...filters];
    newFilters[entityFilterIndex] = newEntityFilter;
    return newFilters;
}

export function updateFiltersWithStatuses(statuses: string[], filters: Filter[], filterName: string): Filter[] {
    const entityOptions = statuses.map((status) => new SelectOption(wfpFormat(status), status));

    const entityFilterIndex = filters.findIndex((filter) => filter.name === filterName);
    const entityFilter = filters[entityFilterIndex] as SelectFilter;
    const newEntityFilter = { ...entityFilter, options: entityOptions };

    const newFilters = [...filters];
    newFilters[entityFilterIndex] = newEntityFilter;
    return newFilters;
}
